<template>
  <div class="content-box">
    <Title />
    <div class="title-right">
      <el-link href="https://www.100ec.cn/zt/lsgwc/" target='_blank'>
        <img src="https://www.100ec.cn/zt/lsgwc/img/960.gif?v=1.2"
      /></el-link>
      
    </div>
    
    <div class="nav-wrapper">
      <div class="vertical-nav">
        <div
          v-for="(primaryItem, primaryIndex) of navData"
          :key="'primary-' + primaryIndex"
          class="nav-row"
        >
          <div
            class="primary-item"
            :class="{ active: isPrimaryActive(primaryIndex) }"
            @click="handlePrimarySelect(primaryIndex)"
          >
            {{ primaryItem.label }}
          </div>
          <div class="secondary-items">
            <span
              v-for="(secondaryItem, secondaryIndex) of primaryItem.children"
              :key="'secondary-' + primaryIndex + '-' + secondaryIndex"
              class="secondary-item"
              :class="{ active: isSecondaryActive(primaryIndex, secondaryIndex) }"
              @click.stop="handleSecondarySelect(primaryIndex, secondaryIndex)"
            >
              {{ secondaryItem.label }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in allNavItems"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activePrimaryIndex: 0,
      activeSecondaryIndex: 0,
      name: "社会责任",
      navData: [
        {
          label: "社会责任",
          children: [
            {
              value: "社会责任",
              label: "滚动播报",
            },
             {
              value: "公益",
              label: "公益",
            },
            {
              value: "驰援",
              label: "驰援",
            },
            {
              value: "救灾",
              label: "救灾",
            },
            {
              value: "救援",
              label: "救援",
            },
            {
              value: "抗疫",
              label: "抗疫",
            },
            {
              value: "援助",
              label: "援助",
            },
            {
              value: "爱心",
              label: "爱心",
            },
            {
              value: "ESG",
              label: "ESG",
            },
            {
              value: "CSR",
              label: "CSR",
            },
           
          ],
        },
        {
          label: "平台类型",
          children: [
            {
              value: "腾讯 公益",
              label: "腾讯公益",
            },
            {
              value: "京东 公益",
              label: "京东公益",
            },
            {
              value: "美团 公益",
              label: "美团公益",
            },
            {
              value: "支付宝 公益",
              label: "支付宝公益",
            },
            {
              value: "滴滴 公益",
              label: "滴滴公益",
            },
            {
              value: "小米 公益",
              label: "小米公益",
            },
            {
              value: "阿里 公益",
              label: "阿里公益",
            },
            {
              value: "唯品会 公益",
              label: "唯品会公益",
            },
          ],
        },
        
        {
          label: "人物",
          children: [
            
            {
              value: "马云 公益",
              label: "马云",
            },
            {
              value: "马化腾 公益",
              label: "马化腾",
            },
            {
              value: "李佳琦 公益",
              label: "李佳琦",
            },
            {
              value: "辛选 公益",
              label: "辛选",
            },
          ],
        },
        {
          label: "公益平台",
          children: [
            {
              value: "红十字",
              label: "红十字",
            },
            {
              value: "壹 基金",
              label: "壹基金",
            },
            {
              value: "小米 基金",
              label: "小米基金",
            },
            {
              value: "阿里 基金",
              label: "阿里基金",
            },
             {
              value: "美团 基金",
              label: "美团基金",
            },
          ],
        },
        {
          label: "灾难",
          children: [
             {
              value: "地震",
              label: "地震",
            },
            {
              value: "火灾",
              label: "火灾",
            },
             {
              value: "水灾",
              label: "水灾",
            },
            {
              value: "香港 火灾",
              label: "香港火灾",
            },
           
            {
              value: "汶川 地震",
              label: "汶川地震",
            },
            {
              value: "玉树 地震",
              label: "玉树地震",
            },
            
          ],
        },
      ],
      params: {
        json: 0,
        filter: ["研报", "分析", "（PPT）", "（全文）"],
      },
    };
  },
  computed: {
    currentSecondaryNav() {
      return this.navData[this.activePrimaryIndex]?.children || [];
    },
    allNavItems() {
      return this.navData.flatMap((item) => item.children);
    },
    currentSelectedItem() {
      const children = this.navData[this.activePrimaryIndex]?.children || [];
      return children[this.activeSecondaryIndex];
    },
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.currentSelectedItem?.value || "社会责任");
    this.$store.dispatch("getText");
  },
  methods: {
    isPrimaryActive(primaryIndex) {
      return this.activePrimaryIndex === primaryIndex && this.activeSecondaryIndex === 0;
    },
    isSecondaryActive(primaryIndex, secondaryIndex) {
      return this.activePrimaryIndex === primaryIndex && this.activeSecondaryIndex === secondaryIndex;
    },
    handlePrimarySelect(primaryIndex) {
      this.activePrimaryIndex = primaryIndex;
      this.activeSecondaryIndex = 0;
      const item = this.navData[primaryIndex]?.children[0];
      const searchKey = item?.keyword || item?.value || "社会责任";
      this.name = item?.label || "社会责任";
      this.$store.commit("changeKeys", searchKey);
      this.$store.dispatch("getText");
    },
    handleSecondarySelect(primaryIndex, secondaryIndex) {
      this.activePrimaryIndex = primaryIndex;
      this.activeSecondaryIndex = secondaryIndex;
      const item = this.navData[primaryIndex]?.children[secondaryIndex];
      const searchKey = item?.keyword || item?.value;
      this.name = item?.label || "";
      this.$store.commit("changeKeys", searchKey);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.name = this.allNavItems.find((item) => item.value === value)?.label || value;
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
.nav-wrapper {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  border-bottom: 2px solid #02973a;
}
.vertical-nav {
  padding: 8px 0;
}
.nav-row {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
  transition: background-color 0.3s ease;
}
.nav-row:last-child {
  border-bottom: none;
}
.nav-row:hover {
  background-color: rgba(2, 151, 58, 0.05);
}
.primary-item {
  flex-shrink: 0;
  min-width: 80px;
  padding: 6px 12px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  text-align: center;
}
.primary-item:hover {
  color: #02973a;
  background-color: rgba(2, 151, 58, 0.1);
}
.primary-item.active {
  color: #fff;
  background-color: #02973a;
}
.secondary-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: 16px;
}
.secondary-item {
  padding: 4px 12px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.8);
}
.secondary-item:hover {
  color: #02973a;
  background-color: rgba(2, 151, 58, 0.1);
}
.secondary-item.active {
  color: #fff;
  background-color: #02973a;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
  .primary-item {
    min-width: 60px;
    padding: 4px 8px;
    font-size: 13px;
  }
  .secondary-item {
    padding: 3px 8px;
    font-size: 12px;
  }
}
@media (max-width: 768px) {
  .nav-row {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 12px;
  }
  .primary-item {
    min-width: 100%;
    text-align: left;
    margin-bottom: 8px;
  }
  .secondary-items {
    margin-left: 0;
    width: 100%;
  }
  .secondary-item {
    flex: 0 0 calc(50% - 4px);
    text-align: center;
  }
}
</style>